import { createFileRoute } from "@tanstack/react-router";
import { ThemeProvider } from "@repo/mfe-core";
import SsoSettingsPage from "../../../../pages/SsoSettings";

export const Route = createFileRoute("/admin/settings/sso-settings/")({
  component: () => (
    <ThemeProvider>
      <SsoSettingsPage />
    </ThemeProvider>
  ),
  validateSearch: (search: Record<string, unknown>) => ({
    success: (search.success as string) || undefined,
  }),
});
